import { useContext, createContext, useMemo } from "react";

type Translations = Record<string, string>;

const defaultStrings: Record<string, string> = {
  feedback: "Feedback de la session",
  grade: "Notation",
  grade1to5: "Notez cette session de 1 à ",
  gradeComment: "Avez-vous un commentaire ?",
  alreadyVoted: "Vous avez déjà voté, merci !",
  cantGradeYet: "Désolé, vous ne pouvez pas encore noter cette session.",
  thanks: "Merci d'avoir voté !",
  "required-error": "Merci de compléter cette question",
};

export const StringContext = createContext<Translations>(defaultStrings);

function useTranslation(): { t: (key: string) => string } {
  const strings = useContext(StringContext);
  return useMemo(() => ({ t: (key: string) => strings?.[key] || defaultStrings[key] }), [strings]);
}

export default useTranslation;
